import api from '@/store/api/customer/product/number'
import { handleApiCall } from '@/store/utils'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    number: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        number: state => state.number
    },
    actions: {
        showNumber: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.showNumber, data, mutationTypes.SET_NUMBER),
        aliasNumberName: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.aliasName, data),
        makeAvailable: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.makeAvailable, data),
        changeOwnership: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.changeOwnership, data),
        portAway: ({ dispatch }, data) => handleApiCall({ dispatch }, api.portAway, data),
        resetNumber: async ({commit}) => commit(mutationTypes.RESET_NUMBER)
    },
    mutations: {
        [mutationTypes.SET_NUMBER]: (state, data) => state.number = data,
        [mutationTypes.RESET_NUMBER]: (state) => Object.assign(state, initialState())
    }
}
